import { QuestionMethods } from '../questionMethods.types';
import {
	RenderedSingleSelectQuestion,
	SingleSelectGivenAnswer,
} from './singleSelectMethods.types';

export const isSingleSelectAnswered: QuestionMethods<
	RenderedSingleSelectQuestion,
	SingleSelectGivenAnswer
>['isAnswered'] = ({ question, givenAnswers }) => {
	const givenAnswer = givenAnswers.single.get(question.id);
	if (givenAnswer === undefined) return false;

	// A null answer indicates the user has explicitly answered "no answer"
	if (givenAnswer === null) return true;

	return question.answers.some((answer) => answer.id === givenAnswer);
};
